import { SimulatePriceRequest } from 'features/simulation/types'
import { SignChannel } from 'store/marketing/types'
import { Language } from 'types/language'
import { Producer } from 'types/producer'

// COMPONENT PROPS

export type RegistrationProps = {
  producer: Producer
}

// ENUMS

export enum InvoiceMedium {
  DIGITAL = 'Digital',
  PAPER = 'Paper'
}

export enum LegalForm {
  SRL_BV = 'SRL/BV',
  SPRLU = 'SPRLU',
  SPRL_BVBA = 'SPRL/BVBA',
  SNC = 'SNC',
  SCS = 'SCS',
  SCRL_CVBA = 'SCRL/CVBA',
  SCA = 'SCA',
  SAGR = 'SAGR',
  SA_NV = 'SA/NV',
  PP = 'PP',
  OTHER = 'Other',
  GIE = 'GIE',
  ASBL_VZW = 'ASBL/VZW',
  ACP = 'ACP'
}

export enum LegalFormSelectOptionKeys {
  BVBA = 'BVBA',
  BV = 'BV',
  NV = 'NV',
  GCV = 'GCV',
  CVBA = 'CVBA',
  VZW = 'VZW',
  EBVBA = 'EBVBA',
  VOF = 'VOF',
  Eenmanszaak = 'Eenmanszaak'
}

export enum PaymentMethod {
  BANK_TRANSFER = 'bankTransfer',
  DIRECT_DEBIT = 'directDebit'
}

export enum Situation {
  SWITCH = 'Supplier Switch',
  MOVE = 'Move',
  NEW_CONNECTION = 'New Connection'
}

export enum RegistrationSteps {
  PERSONAL_DATA = 'Personal Data',
  METER_DETAILS = 'Meter Details',
  BILLING = 'Billing',
  OVERVIEW = 'Overview',
  CONFIRMATION = 'Confirmation'
}

// TYPES

export type Address = {
  /** ISO Country Code */
  countryCode: 'BE'
  /** ZIP Code */
  postalCode: string
  /** Haugazel Town code */
  townCode: number
  /** town name */
  townName: string
  /** Street name */
  streetName: string
  /** House Number */
  streetNumber: string
  /** House Number Suffix */
  streetBox: string
}

export type CreateCustomer = {
  isCompany: boolean
  person: {
    firstName: string
    lastName: string
    birthDate: string
  }
  producer: {
    id: string
    name: string
    sourceRegion: string
    producerSalesforceId: string
  }
  invoicing: {
    invoiceMedium: string
    paymentMethod: string
    ibanNumber: string
  }
  meterInfo: {
    electricity: {
      EAN: string
      exclEAN: string
      indexDay: string
      indexNight: string
      indexExcl: string
      meterNumber: string
    }
    gas: {
      EAN: string
      index: string
      meterNumber: string
    }
    meterReadingMonth?: number
  }
  company?: {
    name: string
    vatApplication: boolean
    vatNumber: string
    legalForm: LegalForm | null
  }
  contact: {
    email: string
    phoneMobile: string
  }
  correspondenceAddress: Address
  deliveryAddress: Address
  language: Language
  knowsMeterDetails: boolean
  instalment: number
  restoreUrl: string
  priceListUrl: {
    electricity: string
    gas: string
  }
  simulation: SimulatePriceRequest
  situation: Situation
  startDateContract: string
  opportunityId: string
  signatureDataUrl?: string
  uploadDataUrl?: string
  signChannel: SignChannel
}

export type Month = {
  i18nKey: string
  defaultValue: string
}

export type StartDateRange = {
  min: Date
  max: Date
  initial: Date
}
